module.exports = function uniqs() {
  var list = Array.prototype.concat.apply([], arguments);
  return list.filter(function(item, i) {
    return i == list.indexOf(item);
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/uniqs/index.js
// module id = 630
// module chunks = 0